<template>
  <div class="menu" v-show="isShowMenu">
    <div class="menu-close" @click="close" />
    <div class="menu-buttons">
      <img class="menu-top" :src="require('../assets/img/menu_top_sp.png')" @click="clickTop()" />
      <img class="menu-notice" :src="require('../assets/img/menu_notice_sp.png')" @click="clickNotice()" />
      <img class="menu-play" :src="require('../assets/img/menu_play_sp.png')" @click="clickPlay()" />
      <img class="menu-gallery" :src="require('../assets/img/menu_gallery_sp.png')" @click="clickGallery()" />
      <img class="menu-twitter" :src="require('../assets/img/menu_twitter_sp.png')" @click="clickTwitter()" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  data() {
    return {
      isShowMenu: false,
    };
  },
  methods: {
    open() {
      this.isShowMenu = true;
    },
    close() {
      this.isShowMenu = false;
    },
    clickTop() {
      if (this.$route.name === 'Top') {
        this.close();
        return;
      }
      this.$router.replace('/');
      this.close();
    },
    clickNotice() {
      if (this.$route.name === 'NoticeList') {
        this.close();
        return;
      }
      this.$router.push('notice-list');
      this.close();
    },
    clickPlay() {
      if (this.$route.name === 'HowToPlay') {
        this.close();
        return;
      }
      this.$router.push('how-to-play');
      this.close();
    },
    clickGallery() {
      if (this.$route.name === 'GalleryList') {
        this.close();
        return;
      }
      this.$router.push('gallery-list');
      this.close();
    },
    clickTwitter() {
      const url = 'https://twitter.com/okazukan_info?ref_src=twsrc%5Etfw';
      window.open(url, '_blank');
      this.close();
    },
  },
};
</script>

<style lang="scss">
.menu {
  background-color: #ffd295;
  height: 100vh;
  width: 100vw;
  position: fixed;
  z-index: 10000;
  top: 0;
  overflow-y: auto;
  text-align: center;

  &-close {
    background-image: url('../assets/img/menuclose_sp.png');
    position: absolute;
    background-size: contain;
    width: 50px;
    height: 50px;
    top: 16px;
    right: 16px;

    @media screen and (min-width: 960px) {
      width: 88px;
      height: 88px;
      top: 24px;
      right: 24px;
    }
  }

  &-buttons {
    width: 100vw;
    max-width: 600px;
    margin: 0 auto;
  }

  &-top,
  &-notice,
  &-play,
  &-gallery,
  &-twitter {
    margin: auto;
    width: 75%;
    max-width: 600px;
    cursor: pointer;
    margin-bottom: 10px;
  }

  &-top {
    margin-top: 80px;
  }
}
</style>
